
export function getLargestAvailableCoupon(currBufferAmount=0) {
  if      (currBufferAmount >= 9) return 9;
  else if (currBufferAmount >= 6)  return 6;
  else if (currBufferAmount >= 3)  return 3;
  else if (currBufferAmount >= 1)  return 1;
  else                             return -1; // no coupon
}



export function toTwoDecimalPlaces(number=0.000, n=2) {
  const splitNum = number.toString().split('.');

  if (n <= 0)
    return splitNum[0];

  let afterDecimal = splitNum[1] || '';
  if (afterDecimal.length > n)
    return `${splitNum[0]}.${afterDecimal.substr(0,n)}`;

  while (afterDecimal.length < n)
    afterDecimal += '0';

  return `${splitNum[0]}.${afterDecimal}`;
}



// WEBPACK FOOTER //
// ./src/pages/helpers.js